"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var errors = _interopRequireWildcard(require("./modules/errors"));
var standard = _interopRequireWildcard(require("./modules/standard"));
var _english = _interopRequireDefault(require("./modules/translations/english"));
var _french = _interopRequireDefault(require("./modules/translations/french"));
var _map = _interopRequireDefault(require("./modules/translations/map"));
var _tokens = _interopRequireDefault(require("./modules/translations/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var _default = exports["default"] = {
  errors: {
    get: function get(errorCode) {
      var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var skipErrorCode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      return errors.getVerbiage(errorCode, language, params, skipErrorCode);
    },
    sysMsg: function sysMsg(errorCode) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return errors.getSysMsg(errorCode, params);
    },
    responseCode: function responseCode(errorCode) {
      return errors.getResponseCode(errorCode);
    }
  },
  standard: {
    get: function get(code) {
      var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      return standard.getVerbiage(code, language, params);
    }
  },
  translations: {
    english: _english["default"],
    french: _french["default"],
    tokens: _tokens["default"],
    map: _map["default"]
  }
};